'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["href", "linkType", "linkDisplayName", "onAnchorPreviewClick"],
  _excluded2 = ["href", "linkType", "linkDisplayName", "onAnchorPreviewClick"],
  _excluded3 = ["href", "linkType", "linkDisplayName", "onAnchorPreviewClick"];
import PropTypes from 'prop-types';
import { Component } from 'react';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIBox from 'UIComponents/layout/UIBox';
import UILink from 'UIComponents/link/UILink';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { LinkTypes } from '../../constants/link';
import { hasHublVariable } from '../../utils/hubl';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = suffix => `RichTextLib.links.${suffix}`;
const MAX_WIDTH = 175;
const PreviewLink = styled(UILink).withConfig({
  displayName: "LinkPreview__PreviewLink",
  componentId: "sc-1uu24u0-0"
})(["display:inline-block;vertical-align:middle;"]);
export default class LinkPreview extends Component {
  constructor(...args) {
    super(...args);
    this.handlePreviewLinkClick = evt => {
      const {
        href,
        linkType,
        onAnchorPreviewClick
      } = this.props;
      if (linkType === LinkTypes.ANCHOR && onAnchorPreviewClick) {
        onAnchorPreviewClick(href);
        evt.preventDefault();
      }
    };
  }
  renderEmailSubscriptionLink() {
    const _this$props = this.props,
      {
        linkDisplayName
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsx(UIBox, Object.assign({}, rest, {
      children: /*#__PURE__*/_jsxs(UIFormLabel, {
        className: "p-y-0 p-x-0",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey(`previewLabel.email_subscription`)
        }), ' ', /*#__PURE__*/_jsx("span", {
          children: linkDisplayName
        })]
      })
    }));
  }
  renderHublLink() {
    const _this$props2 = this.props,
      {
        href
      } = _this$props2,
      rest = _objectWithoutPropertiesLoose(_this$props2, _excluded2);
    return /*#__PURE__*/_jsxs(UIBox, Object.assign({}, rest, {
      children: [/*#__PURE__*/_jsx(UIFormLabel, {
        className: "p-y-0 p-x-0 link-preview-form-label",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey(`previewLabel.url`)
        })
      }), ' ', /*#__PURE__*/_jsx("span", {
        style: {
          display: 'inline-block',
          verticalAlign: 'middle'
        },
        children: /*#__PURE__*/_jsx(UITruncateString, {
          useFlex: true,
          maxWidth: MAX_WIDTH,
          tooltip: false,
          children: href
        })
      })]
    }));
  }
  render() {
    const _this$props3 = this.props,
      {
        href,
        linkType,
        linkDisplayName
      } = _this$props3,
      rest = _objectWithoutPropertiesLoose(_this$props3, _excluded3);
    if (linkType === LinkTypes.EMAIL_SUBSCRIPTION || linkType === LinkTypes.VIEW_AS_WEBPAGE) {
      return this.renderEmailSubscriptionLink();
    } else if (hasHublVariable(href)) {
      return this.renderHublLink();
    } else if (!href || linkType === LinkTypes.NONE) {
      return null;
    }
    return /*#__PURE__*/_jsxs(UIBox, Object.assign({}, rest, {
      children: [/*#__PURE__*/_jsx(UIFormLabel, {
        className: "p-y-0 p-x-0 p-right-2 link-preview-form-label",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey(`previewLabel.${linkType}`)
        })
      }), /*#__PURE__*/_jsx(PreviewLink, {
        external: linkType !== LinkTypes.ANCHOR,
        href: href,
        truncate: true,
        truncateStringProps: {
          maxWidth: MAX_WIDTH,
          tooltip: false
        },
        onClick: this.handlePreviewLinkClick,
        "data-test-id": "preview-link",
        children: linkDisplayName
      })]
    }));
  }
}
LinkPreview.propTypes = {
  href: PropTypes.string.isRequired,
  linkDisplayName: PropTypes.string.isRequired,
  linkType: PropTypes.string.isRequired,
  className: PropTypes.string,
  onAnchorPreviewClick: PropTypes.func
};